import { Text, View } from 'components';
import Base, { Config } from 'components/scourge/Base';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import cx from 'classnames'
import styles from './index.module.scss';
import { history } from 'modules/navigator';


interface State {
  id?: number | string
  purchased: boolean;
  isTryState: boolean;
  tabIndex: number;
  detail: any;
  videoLists: any[];
  videoPage: number;
  videoIsEnd: boolean;
  videoSrc: string;
  playingVideoId?: number;
  isVip: boolean | null
  isYearVip: boolean | null
}

function formateSeconds(endTime:any){
  let secondTime = parseInt(String(endTime))
  let min = 0
  let h =0
  let result=''
  if(secondTime>60){
    min=parseInt(String(secondTime/60))
    secondTime=parseInt(String(secondTime%60))
    if(min>60){
      h=parseInt(String(min/60))
      min=parseInt(String(min%60) )
    }
  }
 result=`${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}`
  return result 
}

export default class videoDetail extends Base<any> {
  public config: Config = {
    navigationBarTitleText: '学习课程'
  };

  public state: State = {
    purchased: false,
    isTryState: false,
    tabIndex: 0,
    detail: {},
    videoLists: [],
    videoPage: 1,
    videoIsEnd: false,
    videoSrc: '',
    isVip: null,
    isYearVip: null
  };

  public async didMount() {
    console.log('first', this.store.globalData.get('videoDetailId'))    
    if(this.props.location.state && this.props.location.state.id){
      this.setState({
        id: this.props.location.state.id
      },() => {
        this.start()
      })
    }else{
      this.navigator.redirect('video')
      return;
    }

    // console.log('this.props.location.state',this.props.location, this.store.globalData.get('videoDetailId'))
    
  }

  // public onReachBottom() {
  //   this.getVideoList()
  // }


  public render() {
    const { tabIndex, purchased, isTryState, detail, videoLists, playingVideoId, videoSrc, isVip, isYearVip } = this.state;


    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        {(purchased || isTryState)? (
          <View className={styles.page}>
            <View className={styles.videoBox}>
              <video 
                className={styles.video} 
                controls={true}
                onPause={this.videoPause}
                onTimeUpdate={this.videoProgress}
                src={videoSrc}
              />
            </View>

            <View className={styles.tabsBox}>
              <View className={styles.tabs}>
                <View onClick={this.tabTrigger.bind(null,0)} className={cx(styles.tab, 
                  {[styles.active]: tabIndex == 0}
                )}>
                  <Text className={styles.p}>课程大纲</Text>
                  <View className={styles.dvd} />
                </View>
                <View onClick={this.tabTrigger.bind(null,1)} className={cx(styles.tab, 
                  {[styles.active]: tabIndex == 1}
                )}>
                  <Text className={styles.p}>课程简介</Text>
                  <View className={styles.dvd} />
                </View>
              </View>

              <View className={styles.body}>
                {tabIndex == 0? (
                  <View>
                    <View className={styles.leftTit}>
                      <Text className={styles.p}>{detail.name} · <Text className={styles.small}>共{detail.class_num}课时</Text></Text>
                    </View>

                    {videoLists && videoLists.map(res => (
                      <View className={styles.classes} onClick={this.playVideo.bind(null,res.id)}>
                        <View className={styles.left}>
                          <Text className={styles.h5}>{res.name}</Text>
                          <Text className={styles.p}>时长：{formateSeconds(res.length)}</Text>
                        </View>
                        <View className={styles.right}>

                          {(playingVideoId != res.id && !purchased)? (
                            <Text className={styles.p}>请购买后观看</Text>
                          ): (
                            <button className={cx(styles.btn, {
                              [styles.red]: playingVideoId == res.id,
                            })}>{playingVideoId == res.id? '播放中': '未开始'}</button>
                          )}
                          
                        </View>
                      </View>
                    ))}
                    
                  </View>
                ): (
                  <View>
                    <View className={styles.information}>
                      <Text className={styles.h2}>{detail.name}
                        {detail.status == 2? (
                          <Text className={styles.yugao}>课程预告</Text>
                        ): (
                          <Text> · 
                            <Text className={styles.small}>总课时</Text>
                            <Text className={cx(styles.small, styles.red)}>{detail.class_num}</Text>
                          </Text>
                        )}
                        
                      </Text>
                      <Text className={styles.p}>{detail.title}</Text>
                    </View>

                    <View className={styles.devider1}/>

                    <View className={styles.sec}>
                      <View className={styles.tit}>
                        <Text className={styles.p}>课程讲师</Text>
                      </View>
                      <View className={styles.content}>
                        {detail.lecturer && 
                          <View className={styles.lecturerBox}>
                            <img className={styles.avatar} src={detail.lecturer.head_img}></img>
                            <View className={styles.lteBoxRight}>
                              <Text className={styles.p}>{detail.lecturer.name}</Text>
                              <Text className={styles.p}>{detail.lecturer.job}</Text>
                            </View>
                          </View>
                        }
                      </View>
                    </View>
                    {this.renderDESC()}
                  </View>
                )}
                
              </View>
            </View>
          </View>
        ): (
          <View className={styles.page}>

            <View className={styles.banner}>
              {detail.lecturer && 
                <View className={styles.lecturer}>
                  <img className={styles.avatar} src={detail.lecturer.head_img}></img>
                  <View className={styles.tags}>
                    <Text className={styles.tag}>{detail.lecturer.name}</Text>
                    <Text className={styles.tag}>{detail.lecturer.job}</Text>
                  </View>
                </View>
              }
              <button className={styles.shareBtn} style={{display: 'none'}}>分享</button>
              
            </View>

            <View className={styles.information}>
              <Text className={styles.h2}>{detail.name}

                {detail.status == 2? (
                  <Text className={styles.yugao}>课程预告</Text>
                ): (
                  <Text> · 
                    <Text className={styles.small}>总课时</Text>
                    <Text className={cx(styles.small, styles.red)}>{detail.class_num}</Text>
                  </Text>
                )}

              </Text>
              <Text className={styles.p}>{detail.title}</Text>
              {detail.status != 2 && <Text className={cx(styles.p, styles.tr)}>{detail.sale_num}人已加入</Text>}
            </View>


            <View className={styles.body}>
              {detail.status == 2 && 
                <View className={cx(styles.sec, styles.reserveAlert)}>
                  <View className={styles.tit}>
                    <Text className={styles.p}>温馨提示</Text>
                  </View>
                  <View className={styles.content}>
                    <Text className={cx(styles.p, styles.red)}>该课程很快上线，请近期关注</Text>
                  </View>
                </View>
              }

              {this.renderDESC(1)}
            </View>
            
          </View>
        )}


        {detail.id && (
          <View>
            {detail.status == 2? (
              <View className={styles.bottom}>
                <View className={styles.notInterest} onClick={this.handleBack}>
                  <Text className={styles.p}>不感兴趣</Text>
                </View>
                <button className={cx(styles.btn, styles.red)} onClick={this.handleReserve}>
                  <img src={this.assets.scorponok.videoRegist} style={{width:17}} />
                  <Text className={styles.p} style={{marginLeft: '10px'}}>感兴趣，点击此处登记</Text>
                </button>
                
              </View>
            ): (purchased)? (
              <View className={styles.bottom}>
                {purchased && (
                  <button className={cx(styles.btn, styles.red)}>
                    <Text className={styles.h5}>分享</Text>
                  </button>
                )}
                {!purchased && (
                  <button className={cx(styles.btn, styles.red)} onClick={this.handlePurchase}>
                    <Text className={styles.h5}>立即购买￥{isVip? (isYearVip? detail.year_vip_price: detail.quarter_vip_price): detail.sale_price}</Text>
                  </button>
                )}
              </View>
            ):(
              <View className={styles.bottom}>

                {isVip &&  (
                  <View className={cx(styles.btn, styles.red)} onClick={this.handlePurchase}>
                    <Text className={styles.h2}>会员价￥{isYearVip? detail.year_vip_price: detail.quarter_vip_price}</Text>
                    <Text className={styles.small}>非会员价￥{detail.sale_price}</Text>
                  </View>
                )}

                {!isVip && (
                  <View className={cx(styles.btn, styles.pink)} onClick={this.handlePurchase}>
                    <Text className={styles.p}>直接购买￥<Text className={styles.b}>{detail.sale_price}</Text></Text>
                  </View>
                )}
                {!isVip && (
                  <View className={cx(styles.btn, styles.red)} onClick={this.handleClickVip}>
                    <Text className={styles.p}>会员价￥<Text className={styles.b}>{detail.year_vip_price}</Text></Text>
                  </View>
                )}
                
                
              </View>
            )}
          </View>
        )}
        
        

      </View>
    );
  }

  private renderDESC = (type:number = 0) => {
    const { detail, videoLists } = this.state
    return (
      <View>
        {detail.lecturer && 
          <View className={styles.sec}>
            <View className={styles.tit}>
              <Text className={styles.p}>讲师简介</Text>
            </View>
            <View className={styles.content}>
              <Text className={styles.p}>{detail.lecturer.desc}</Text>
            </View>
          </View>
        }
        <View className={styles.sec}>
          <View className={styles.tit}>
            <Text className={styles.p}>课程亮点</Text>
          </View>
          <View className={styles.content}>
            <Text className={styles.p}>{detail.desc}</Text>
          </View>
        </View>
        <View className={styles.sec}>
          <View className={styles.tit}>
            <Text className={styles.p}>课程大纲</Text>
          </View>
          <View className={styles.content}>

            {videoLists && videoLists.map(res =>(
              <View className={cx(styles.lis, {
                [styles.trylis]: type == 1 && res.can_try == 1
              })}>
                <Text className={styles.p}>{res.name}</Text>
                {type == 1 && res.can_try == 1 && 
                  <View className={styles.try} onClick={this.handleTry.bind(null, res.id)}>
                    <img src={this.assets.scorponok.replay} style={{width:12}} />
                    <Text className={styles.p}>点此试听</Text>
                  </View>
                }
              </View>
            ))}
            
          </View>
        </View>
        {detail.status != 2 &&
          <View className={styles.sec}>
            <View className={styles.tit}>
              <Text className={styles.p}>购买须知</Text>
            </View>
            <View className={styles.content}>
              <Text className={styles.p}>1、包含课程视频、随堂测试、完整讲义文稿等内容</Text>
              <Text className={styles.p}>2、您将购买的商品为虚拟内容服务、购买后不支持退订、转让、退换，请斟酌确认</Text>
            </View>
          </View>
        }
      </View>
    )
  }

  private get isIOS() {
    return false;
  }

  private start = async() => {
    const { isVip } = this.state
    if(isVip == null){
      const vipinfo = await this.store.user.getVipInfo()
      this.setState({
        isVip: !!(vipinfo && vipinfo.id),
        isYearVip: !!(vipinfo && vipinfo.vip_name.indexOf('年') > -1)
      })
    }

    await Promise.all([this.getData(), this.getVideoList()])
    this.getFirstVideo()
  }

  private handleBack = () => {
    // this.navigator.back().catch(err => {
    //   this.navigator.reLaunch('videoLists')
    // })
    this.navigator.back()
  }

  private toTop = () => {
    window.scroll(0,0)
  }

  private get sharePrice(){
    const {detail} = this.state
    return Number(detail.origin_price) * 0.3 || 0
  }

  private videoCurrentTime:number = 0
  private videoProgress = e => {
    if(e){
      this.videoCurrentTime = e.detail.currentTime
    }
  }

  private videoPause = async(e) => {
    const { playingVideoId } = this.state
    await this.apiClient.base.videoProgress({
      id: playingVideoId,
      second: this.videoCurrentTime
    })
    // console.log('videoPause', e, this.videoCurrentTime)

  }

  private handleClickVip = () => {
    // if(this.isIOS){
    //   this.feedback.showModal({
    //     title:'提示',
    //     content: '只有会员才能享受会员价！',
    //     confirmText: '会员介绍',
    //     success: res => {
    //       if(res.confirm){
    //         this.navigator.push('join')
    //       }
    //     }

    //   })
    // }else {
      history.push('/scorponok/vip')
    // }
  }

  private handleReserve = async() => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }

    const phone = await this.store.user.getUserPhone()
    const { status, msg } = await this.apiClient.base.reserveCourse({
      id: this.state.id,
      phone
    })
    if(status == 10000) {
      toast.success('登记成功！',{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }else {
      toast.error(msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
  }

  private tabTrigger = (ind: number) => {
    this.setState({
      tabIndex: ind
    })
  }
  
  private handlePurchase = async() => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }

    
    const res = await this.apiClient.base.buyCourse({
      id: this.state.id
    })

    if(res.status == 10000) {

      const paymentConfig = {
        appId: res.body.appId,
        nonceStr: res.body.nonceStr,
        package: res.body.package,
        paySign: res.body.paySign,
        signType: res.body.signType,
        timestamp: res.body.timeStamp
      };

      this.interface.requestPayment(paymentConfig).then(res => {
        if (res.errMsg === 'chooseWXPay:ok') {
          toast.success('支付成功！',{
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
            closeButton: false,
          })
          this.start();
          window.location.reload()
        }
      }).catch(err => {
        console.log(err)
        toast.error('支付失败！',{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
      });


    }else {
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }

  }

  private handleFree = async() => {
    const { detail, isVip, isYearVip, purchased } = this.state
    if(purchased){
      //买了就算了
      return;
    }
    if((isVip && isYearVip && Number(detail.year_vip_price) == 0) || (isVip && !isYearVip && Number(detail.quarter_vip_price) == 0) || (!isVip && Number(detail.sale_price) == 0)) {
      //免费课程，主动创一个订单
      const res = await this.apiClient.base.buyCourse({
        id: this.state.id
      })
      if(res.status == 10000) {
        this.getData()
      }
    }
  }

  private getData = async() => {
    return new Promise(async(resolve, reject) => {
      const res = await this.apiClient.base.getCourse({
        id: this.state.id
      })
      if(res.status == 10000) {
        this.setState({
          detail: res.body,
          purchased: res.body.is_buy,
        },() => {
          this.handleFree()
          resolve(true)
        })
        
        if(res.body.is_buy){
          this.setState({
          detail: res.body,
            isTryState: false
          })
        }

      }else {
        toast.error(res.msg,{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
        reject(false)
      }
    })
  }

  private getVideoList = async() => {
    const { videoLists, videoPage, videoIsEnd } = this.state

    return new Promise(async(resolve, reject) => {
      if(videoIsEnd) {
        return;
      }
      const res = await this.apiClient.base.videoList({
        cid: this.state.id,
        page: videoPage
      })
      if(res.status == 10000) {
        const newList = [...videoLists, ...res.body];

        this.setState({
          videoLists: newList,

          videoPage: videoPage+1,
          videoIsEnd: res.body.length < 1
        },() => {
          resolve(true)
        })
      }else {
        toast.error(res.msg,{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
        reject(false)
      }
    })
    
  }

  private handleTry = async( id?:number ) => {
    console.log('try',id)
    this.playVideo(id)
    this.setState({
      isTryState: true
    },
      this.toTop
    )
  }

  private playVideo = async(id) => {
    const res = await this.apiClient.base.videoDetail({
      id
    })
    console.log(id,res)
    if(res.status == 10000) {
      this.setState({
        playingVideoId: id,
        videoSrc: res.body.url
      })
    }else {
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
  }

  private getFirstVideo = () => {
    const { purchased, videoLists } = this.state;
    
    if(purchased && videoLists.length > 0) {
      const id = videoLists[0].id
      this.playVideo(id)
    }
  }



}
